import { render, staticRenderFns } from "./Extremum.vue?vue&type=template&id=42fbe68e&scoped=true&"
import script from "./Extremum.vue?vue&type=script&lang=js&"
export * from "./Extremum.vue?vue&type=script&lang=js&"
import style0 from "./Extremum.vue?vue&type=style&index=0&id=42fbe68e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fbe68e",
  null
  
)

export default component.exports